import { createContext, Dispatch } from 'react';

export const HistoryReducerDefaultValues = {
  user: 'All',
  usersList: [] as string[],
};

export enum HistoryActionType {
  SetUser = 'SetUser',
  SetUsersList = 'SetUsersList',
}

type State = typeof HistoryReducerDefaultValues;
type Action = {
  type: HistoryActionType;
  payload: string | string[];
};

export const historyReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case HistoryActionType.SetUser:
      return { ...state, user: payload as string };
    case HistoryActionType.SetUsersList:
      return { ...state, usersList: payload as string[] };
    default:
      return state;
  }
};

export const HistoryContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
